import {
  buttonClasses,
  buttonIconClasses,
} from "@/design-system/Button/Button";
import { trackGetApp } from "@/events/landingPagesMixpanel";
import { cn } from "@/lib/utils";
import { androidAppUrl } from "@/settings";
import { useTranslation } from "@repo/shared/i18n";

import { AndroidIcon } from "./PlatformIcons";

/** The Android beta's Play listing, as a primary button. */
export const AndroidBetaLink = ({
  stretch,
  className,
}: {
  stretch?: boolean;
  className?: string;
}) => {
  const { t } = useTranslation("appLanding");
  return (
    <a
      href={androidAppUrl("app_page")}
      target="_blank"
      rel="noreferrer"
      onClick={() => trackGetApp("app_page")}
      className={buttonClasses({
        variant: "primary",
        size: "medium",
        stretch,
        className: cn("font-semibold whitespace-nowrap", className),
      })}
    >
      <span className={buttonIconClasses({ size: "medium" })}>
        <AndroidIcon />
      </span>
      <span>{t("androidBeta.cta")}</span>
    </a>
  );
};
